module.exports = __webpack_public_path__ + "static/media/mongoDB.85be6807.svg";